import styled from 'styled-components';
import { FiAlertCircle } from 'react-icons/fi';
import { FaRegCheckCircle } from 'react-icons/fa';
import { Checkbox } from '@unimed-fesp/components';

import theme from '../../../styles/theme';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;

  svg {
    height: 60px;
    width: 60px;
  }
`;

export const ContentText = styled.div`
  align-self: center;
  margin: 0 auto;
  margin-bottom: 30px;
  margin-top: 28px;
  max-width: 380px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Text = styled.p`
  font: normal normal normal 15px 'Calibri';
  color: ${theme.colorGray};
  text-align: center;
`;

export const Content = styled.div`
  padding: 10px;
  align-self: center;
`;

export const TextHeader = styled.strong`
  font: normal normal 800 34px/43px 'work_sans';
  color: ${theme.titleGray};
  text-align: center;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;

export const TextHeaderBold = styled.strong`
  font: normal normal 800 34px/43px 'unimed_slabbold';
  color: ${theme.titleGray};
  text-align: center;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;

export const IconAlert = styled(FiAlertCircle)`
  color: ${theme.yellowDefault};
  width: 83px;
  height: 83px;
  margin-bottom: 8px;
  margin-left: 25px;
`;

export const IconSuccess = styled(FaRegCheckCircle)`
  color: ${theme.greenDefault};
  width: 100px;
  height: 100px;
  margin-bottom: 8px;
  margin-left: 25px;
`;

export const CheckboxWithText = styled(Checkbox)`
  margin-bottom: 18px;
  > p {
    margin-bottom: 18px;
    color: ${theme.colorGray};
    font: normal normal normal 14px/20px 'Calibri';
    margin-right: 0px;
  }

  > p > a {
    color: ${theme.green1};
    font-weight: bold;
  }
`;
